<nx-ng-modal-header
  [showTicket]="false"
  [title]="'delivery_m_ticket_title' | i18next"
></nx-ng-modal-header>
<mat-dialog-content>
  <nx-ng-bus-e-commerce-renderer
    [markdown]="'m_ticket_info_modal_part_one' | i18next"
  >
  </nx-ng-bus-e-commerce-renderer>
  <img
    [src]="
      this.imageUrlService.getImageUrl('/assets/images/app-menu-screenshot.png')
    "
    alt="menu placeholder image"
    style="width: 100%"
  />
  <nx-ng-bus-e-commerce-renderer
    [markdown]="'m_ticket_info_modal_part_two' | i18next"
  >
  </nx-ng-bus-e-commerce-renderer>
  <img
    [src]="
      this.imageUrlService.getImageUrl(
        '/assets/images/my-profile-screenshot.png'
      )
    "
    alt="my profile placeholder image"
    style="width: 100%"
  />
  <nx-ng-bus-e-commerce-renderer
    [markdown]="'m_ticket_info_modal_part_three' | i18next"
  >
  </nx-ng-bus-e-commerce-renderer>
  <img
    [src]="
      this.imageUrlService.getImageUrl(
        '/assets/images/new-account-screenshot.png'
      )
    "
    alt="my profile placeholder image"
    style="width: 100%"
  />
  <nx-ng-bus-e-commerce-renderer
    [markdown]="'m_ticket_info_modal_part_four' | i18next"
  >
  </nx-ng-bus-e-commerce-renderer>
  <img
    [src]="
      this.imageUrlService.getImageUrl(
        '/assets/images/ticket-wallet-screenshot.png'
      )
    "
    alt="my profile placeholder image"
    style="width: 100%"
  />
</mat-dialog-content>
